module.exports = __webpack_public_path__ + "static/img/profile-target-3.7f7f2130.png";